import { Box, Button, Divider, Flex, HStack, Icon, Image, Link, Text, useColorMode } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FiLogIn } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { assets } from "../../../../assets/assets";
import { urls } from "../../../../urls";

interface Props {
  children: React.ReactNode;
}

export const PortalLayout = ({ children }: Props) => {
  const { t } = useTranslation();
  const theme = useColorMode();

  return (
    <Box minH="100vh" bg="smBackgroundSecondary">
      <Box borderTop="3px solid" borderTopColor="smPrimary" bg="smBackground" borderBottom="1px solid" borderBottomColor="smBorder">
        <Flex width="full" maxW="container.xl" mx="auto" align="center" justify="space-between" px={{ base: "4", md: "6" }} py="3">
          <Image src={theme.colorMode === "dark" ? assets.logo_dark : assets.logo} alt="SourceMagnet" h="28px" />

          <HStack spacing={{ base: "3", md: "5" }}>
            <Link
              as={RouterLink}
              to={urls.portal.list}
              color="smPrimary"
              fontSize="sm"
              fontWeight="semibold"
              display={{ base: "none", md: "inline-flex" }}
              _hover={{ textDecoration: "none", color: "smPrimarySoft" }}
            >
              {t("Procurements")}
            </Link>

            <Divider orientation="vertical" height="24px" borderColor="smBorder" display={{ base: "none", md: "block" }} />

            <Button
              as={RouterLink}
              to={urls.login}
              size="sm"
              variant="outline"
              color="smPrimary"
              leftIcon={<Icon as={FiLogIn} />}
              borderColor="smBorder"
              _hover={{ bg: "smPrimarySofter" }}
            >
              {t("Log in")}
            </Button>
          </HStack>
        </Flex>
      </Box>

      <Box width="full" maxW="container.xl" mx="auto" px={{ base: "4", md: "6" }} py={{ base: "6", md: "8" }}>
        {children}
      </Box>

      <Flex justify="center" px="4" py="8">
        <Text color="smMuted" fontSize="sm">
          © 2026 SourceMagnet · {" "}
          <Link href="https://www.sourcemagnet.com/privacy-policy" isExternal color="smMuted" textDecoration="underline">
            {t("Privacy Policy")}
          </Link>
        </Text>
      </Flex>
    </Box>
  );
};
